import React from "react";
import RealtimeAuditTable from "../../../Components/RealtimeAuditTable/RealtimeAuditTable";

const SoundRecordingTableView = () => {
  // Define the columns for music video asset embeddings table
  const columns = [
    {
      field: "musicVideoId",
      header: "Music Video ID",
      sortable: true,
      filter: true,
    },
    {
      field: "soundRecordingId",
      header: "Sound Recording ID",
      sortable: true,
      filter: true,
      render: (value: string) => value || "Not Linked",
    },
    {
      field: "videoId",
      header: "Video ID",
      sortable: true,
      filter: true,
      render: (value: string) => value || "N/A",
    },
    {
      field: "isrc",
      header: "ISRC",
      sortable: true,
      filter: true,
      render: (value: string) => value || "Missing",
    },
    {
      field: "artist",
      header: "Artist",
      sortable: true,
      filter: true,
      render: (value: string) => value || "Missing",
    },
    {
      field: "label",
      header: "Label",
      sortable: true,
      filter: true,
      render: (value: string) => value || "Missing",
    },
    {
      field: "customId",
      header: "Custom ID",
      sortable: true,
      filter: true,
      render: (value: string) => value || "Missing",
    },
    {
      field: "updatedAt",
      header: "Last Updated",
      sortable: true,
      filter: true,
      render: (value: any) => {
        if (!value) return "N/A";
        const date = value.toDate
          ? value.toDate()
          : new Date(value._seconds * 1000 || value);
        return date.toLocaleString();
      },
    },
  ];

  // Define actions that users can perform on each row
  const actions = [
    {
      label: "View YouTube Asset",
      icon: "pi pi-youtube",
      onClick: (row: any) => {
        if (row.musicVideoId) {
          // Open YouTube Studio asset page
          const url = `https://studio.youtube.com/asset/${row.musicVideoId}/metadata/overview?o=2FgLC4rERnU_KMmQsEuxBw`;
          window.open(url, "_blank");
        }
      },
      severity: "info" as const,
      outlined: true,
    },
  ];

  return (
    <div className="space-y-6">
      {/* Header */}

      {/* Realtime Audit Table */}
      <RealtimeAuditTable
        collectionName="musicVideoAssetEmbeddings"
        columns={columns}
        title="Music Video Asset Embeddings"
        actions={actions}
        limitCount={50} // Latest 50 entries
        orderByField="updatedAt"
        orderDirection="desc"
        showNewIndicator={true} // Show new entries indicator
      />
    </div>
  );
};

export default SoundRecordingTableView;
